<template>
  <div id="index">
    <Header ref="header"></Header>
    <!-- 推荐产品 -->
    <div class="index5 productList" :class="morenDiv == false ? 'none':''" style="margin-top:20px">
      <div class="index5Box productListBox">
        <div class="newsDetails">
          <h4>胡椒价格趋于平稳</h4>
          <h6>2022-05-12 17:32</h6>
          <p>
                  胡椒出口价格也出现暴涨。今年前4个月，胡椒出口7.9万吨，同比下降15.5%；出口额3.67亿美元，同比增
长29.6%。今年前3个月胡椒出口均价达到4664美元/吨，同比增长59.6%。一季度越南最大的胡椒出口市场
是美国、印度和德国（占市场份额的43.5%）。据越南农产品加工和市场开发局预测，在全球消费需求高企
的情况下，这些农产品的出口价格将继续上涨。特别是对于水产品来说，中国和美国是增加进口的两个重点
市场。美国农业部 (USDA) 预测2021-2022作物年度的全球咖啡产量将比上一作物年度减少850万袋（相当于
减少 4.8%）降至1.675亿袋。因此，当需求高而供应减少时，咖啡的价格将会继续上涨。
                </p>
          <p style="width:100%;height:500px"></p>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="foot">
        <ul>
          <li>电话：0558-5858131</li>
          <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
          <li>安徽广盛堂中药饮片有限公司 版权所有 免责声明 皖ICP备18026442号</li>
          <li>皖公网安备 3416020200060号</li>
        </ul>
        <img src="../assets/img/footerImg.jpg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/header'
export default {
  components: {
    Header
  },
  data() {
    return {
      morenDiv:true,
      showLogin:true,
      EWMImg:false,
      EWMButton:true,
      productDetailsImg:require('../assets/img/productDetailsIconImg.png'),
      productImgList:[
        {id:"001",imgUrl:require('../assets/img/productDetailsImg1.png')},
        {id:"002",imgUrl:require('../assets/img/productDetailsImg2.png')},
        {id:"003",imgUrl:require('../assets/img/productDetailsImg3.png')},
        {id:"003",imgUrl:require('../assets/img/productDetailsImg4.png')},
        {id:"003",imgUrl:require('../assets/img/productDetailsImg5.png')}
      ],
    }
  },
  mounted() {
    if(this.$cookie.get('account') == null){
      this.showLogin = true
    }else{
      this.showLogin = false
    }
    this.getArticleDetails();
  },
  methods: {
    getArticleDetails(){
      this.$fetch('getArticleDetails',{id:this.$router.id}).then(res => {
       this.newsList = res.result.records;
       this.totalNum = res.result.total;
      })
    }
  }
}
</script>
<style>
  @import "../assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/components/noticeDetails.vue